import React from "react"
import {View} from "@instructure/ui-view";
import TextCharacters from './special-text';
import MathsCharacters from './special-maths';
import LatinCharactersSupplemental from './special-latin-sup';
import LatinCharactersExtendedA from './special-latin-ext-a';
import CurrencyCharacters from './special-currency';
import ArrowsCharacters from './special-arrows';
import PhysicsCharacters from './special-physics';
import {Button} from "@instructure/ui-buttons";
import {ToggleGroup} from "@instructure/ui-toggle-details";
import PropTypes from "prop-types";

class SpecialCharacters extends React.Component {
    
    static propTypes = {
        // Function to handle when someone clicks on a character.
        onCharacters: PropTypes.func,
        // An additional character set.
        characters: PropTypes.object,
        // Recently used character set.
        used: PropTypes.object
    }

    renderCharacters(characterClass) {
        return <ToggleGroup toggleLabel={(expanded) => (expanded ? 'Collapse' : 'Expand') + characterClass.title} summary={characterClass.title}
                            defaultExpanded={true} border={false}>
            <View as='div'>
                {
                    characterClass.characters.map(item => {
                        return <Button key={item.character} margin='xx-small' title={'Insert '+ item.character}
                                       onClick={() => this.props.onCharacter(item)}>
                            {item.character}
                        </Button>
                    })
                }
            </View>
        </ToggleGroup>

    }

    render() {
        return <View as='div' padding='small'>
            {this.props.used && this.renderCharacters(this.props.used)}
            {this.props.characters && this.renderCharacters(this.props.characters)}
            {this.renderCharacters(TextCharacters)}
            {this.renderCharacters(MathsCharacters)}
            {this.renderCharacters(LatinCharactersSupplemental)}
            {this.renderCharacters(LatinCharactersExtendedA)}
            {this.renderCharacters(CurrencyCharacters)}
            {this.renderCharacters(ArrowsCharacters)}
            {this.renderCharacters(PhysicsCharacters)}
        </View>

    }
}

export default SpecialCharacters